module.exports = __webpack_public_path__ + "static/img/AI-1.e67b560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI-1.png
// module id = 9Qcg
// module chunks = 36